var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"controller-inner"},[_c('base-input-range',{attrs:{"step":"0.01","min":"0","max":"360","value":_vm.value},on:{"input":_vm.updateValue}}),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.displayValue))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }